import React from 'react';

export default function PersonDocumentNumberFields({ form, onChange }) {
  return <>
    <label className="record-profile__field--susCardNumber"><span>Número do cartão do SUS</span><input type="text" maxLength={50} value={form.susCardNumber || ''} onChange={event => onChange('susCardNumber', event.target.value)} /></label>
    <label className="record-profile__field--birthCertificateNumber"><span>Número da certidão de nascimento</span><input type="text" maxLength={60} value={form.birthCertificateNumber || ''} onChange={event => onChange('birthCertificateNumber', event.target.value)} /></label>
  </>;
}
